import React from 'react'
import PropTypes from "prop-types"
import styled from 'styled-components'
import Header from './sectionHeader'
const Container = styled.section`
  grid-area: main;
  margin-top: 5.4em;
  
`

const Inner = styled.div`
  grid-area: content;
`


const Section = ({ children, title, subtitle, description, anchor, effect }) => (
  <Container className="container" id={anchor}>
    <Inner data-aos={effect ? 'zoom-out' : ''} data-aos-duration="600">
      <Header key={1} title={title} subtitle={subtitle} description={description} />
      {children}
    </Inner>
  </Container>
)


export default Section;

 
Section.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  anchor: PropTypes.string,
  effect: PropTypes.bool,
}

Section.defaultProps = {
  title: ``,
  subtitle: '',
  anchor: '',
  description: '',
  effect: true
}